<script>
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';

export default {
  computed: {
    current() {
      return this.$route.params.date || moment().format(DateFormat.Canonical);
    },
    from() {
      return this.current;
    },
    to() {
      return this.current;
    },
  },
  methods: {
    prev() {
      this.$router.push({ name: 'calendar-day', params: {
        date: moment(this.current).subtract(1, 'days').format(DateFormat.Canonical),
      }});
    },
    next() {
      this.$router.push({ name: 'calendar-day', params: {
        date: moment(this.current).add(1, 'days').format(DateFormat.Canonical),
      }});
    },
    format(date) {
      return moment(date).format(DateFormat.DefaultDisplay);
    },
  },
};
</script>
